import { render, staticRenderFns } from "./nxtStepAfterButton.vue?vue&type=template&id=24479c9f&scoped=true"
import script from "./nxtStepAfterButton.vue?vue&type=script&lang=js"
export * from "./nxtStepAfterButton.vue?vue&type=script&lang=js"
import style0 from "./nxtStepAfterButton.vue?vue&type=style&index=0&id=24479c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24479c9f",
  null
  
)

export default component.exports